import React, { useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Form, Field, Formik } from 'formik';
import { YupSchema } from '../../../shared/constants/chatbot-validators';
import TextInput from './CustomField/TextInput';

export default function RentForm(props) {
  const { t } = useTranslation('saleModal');
  const validateSchema = new YupSchema(t).rentForm;
  const formState = useRef();
  const initialValues = props.initialValues

  const handleTriggerNextStep = async(values) => {
    await formState.current.setFieldTouched();
    await formState.current.validateForm()

    if (!formState.current.isValid) return;

    const contact = JSON.parse(window.lsSession.getItem(`chatbot-${props.formType}`))
    const newObj = {...contact, ...values}
    const contactStr = JSON.stringify(newObj)
    window.lsSession.setItem(`chatbot-${props.formType}`, contactStr)
    props.triggerNextStep({ trigger: props.trigger, value: values, replaceAll: props.step.id })
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validateSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleTriggerNextStep}
    >
      {(formikProps) => {
        const { handleSubmit } = formikProps;
        formState.current = formikProps;

        return (
          <Form onSubmit={handleSubmit}>
            <div className="selectOption">
              <div className="titleSelect">全体の部屋数</div>
              <Field name="rental_status_total" component={TextInput} numberonly="true" type="text" placeholder="入力してください。" />
            </div>
            <div className="selectOption">
              <div className="titleSelect">賃貸中の部屋数</div>
              <Field name="rental_status_operation" component={TextInput} type="text" numberonly="true" placeholder="入力してください。" />
            </div>
            <div className="selectOption">
              <div className="titleSelect">備考欄</div>
              <Field name="rental_status_remarks" component={TextInput} type="text" placeholder="入力してください。" />
            </div>
            <button type="submit" className="btnSubmit">
              決定
            </button>
          </Form>
        )
      }}
    </Formik>
  )
}
